import type { AnyAction } from 'redux';

import type { PartFileStandaloneViewerData } from '@frontend/api';

import { types } from './actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Store = {
  modules: { fileViewer: FileViewerState };
};

export type FileViewerState = {
  activeRootFile?: PartFileStandaloneViewerData | null;
};

const initialState = (): FileViewerState => ({
  activeRootFile: null,
});

const reducer = (state = initialState(), action: AnyAction) => {
  const { payload, type } = action;
  switch (type) {
    case types.INIT_FILE_VIEWER:
      return {
        ...state,
        activeRootFile: payload.activeRootFile,
      };
    case types.UPDATE_ITAR_STATUS:
      return {
        ...state,
        activeRootFile: {
          ...state.activeRootFile,
          isExportControlled: payload.isExportControlled,
        },
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state: Store) => state.modules.fileViewer as FileViewerState;

export const getActiveRootFileUuid = (state: Store) =>
  getScope(state).activeRootFile?.uuid;

export const getActiveRootFile = (state: Store) =>
  getScope(state).activeRootFile;

export const getActiveRootFileName = (state: Store) =>
  getScope(state).activeRootFile?.filename;
